<script type="module">
import axios from 'axios'
import { format } from 'date-fns/format'
import { addDays } from 'date-fns/addDays'
import { startOfTomorrow } from 'date-fns/startOfTomorrow'
import ModalBus from '@/eventBus'

export default {
  name: 'QuoteFormAccommodation',

  props: {
    countriesList: Array,
    accommodationListUrl: String,
    accommodation_id: Number,
  },

  data() {
    return {
      hasComment: false,
      countries: this.countriesList,
      hours: [],
      form: {
        token: '',
        lastname: window.Laravel.user?.lastname,
        firstname: window.Laravel.user?.firstname,
        email: window.Laravel.user?.email,
        country: window.Laravel.user?.country,
        phone: window.Laravel.user?.phone,
        message: null,
        specific_fields: {
          booking: {
            adults: null,
            child: null,
            babies: null,
            start_date: format(startOfTomorrow(), 'yyyy-MM-dd'),
            end_date: format(addDays(startOfTomorrow(), 1), 'yyyy-MM-dd'),
            accommodation_id: this.accommodation_id,
          },
        },
      },

      sending: false,
      errorMessage: '',
      successMessage: '',
      errors: undefined,
    }
  },

  methods: {
    toggleComment() {
      this.hasComment = !this.hasComment
    },

    closeForm() {
      ModalBus.emit('close')
    },

    handleSubmit() {
      this.sending = true
      this.errorMessage = ''
      this.errors = undefined
      this.successMessage = ''

      this.$recaptcha('accomodation').then((token) => {
        this.form.token = token
        axios
          .post('/submission/accomodation', this.form)
          .then((response) => {
            this.successMessage = response.data.message
            this.$root.openSuccessQuoteFormAccommodation({
              url: this.accommodationListUrl,
            })
          })
          .catch((error) => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors || {}
            } else if (error.response.status === 500 || error.response.status === 401) {
              this.errorMessage = error.response.data.message
            }
          })
      })
    },
  },
}
</script>

<template>
  <div class="overflow-scroll border border-lightgray bg-white lg:rounded-2xl">
    <div class="item-center flex justify-between border-b-2 border-light/25 px-6 py-4">
      <div class="flex items-center">
        <span class="font-poppins text-xl font-medium">
          {{ $t('accommodations.quoteForm.title') }}
        </span>
      </div>
      <button
        class="relative h-10 w-10 rounded-full bg-secondary focus:outline-none lg:hidden"
        @click="closeForm">
        <div
          class="absolute left-1/2 top-1/2 flex h-1/2 w-1/2 -translate-x-1/2 -translate-y-1/2 flex-col items-end justify-between">
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full rotate-45 rounded bg-white"></div>
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full -rotate-45 rounded bg-white"></div>
        </div>
      </button>
    </div>
    <form
      method="POST"
      @submit.prevent="handleSubmit">
      <div class="p-5">
        <div
          v-if="errorMessage"
          class="relative mb-3 mt-3 rounded-lg bg-red-100 px-3 py-3 text-sm text-red-700">
          {{ errorMessage }}
        </div>
        <div
          v-if="successMessage"
          class="relative mb-3 mt-3 rounded-lg bg-emerald-100 px-3 py-3 text-sm text-emerald-700">
          {{ successMessage }}
        </div>

        <div class="flex w-full items-center">
          <user class="h-4 w-4 text-primary"></user>
          <h3 class="ml-4 font-poppins text-xl font-medium">
            {{ $t('commons.quoteForm.customerInfos.title') }}
          </h3>
        </div>
        <div class="w-full">
          <div class="grid grid-cols-2 gap-x-4">
            <label class="form__label">
              <span>{{ $t('commons.quoteForm.customerInfos.lastname.label') }}</span>
              <input
                v-model="form.lastname"
                :placeholder="$t('commons.quoteForm.customerInfos.lastname.placeholder')"
                class="form__input bg-lightgray md:bg-white"
                name="lastname"
                type="text" />
              <span
                v-if="errors && errors['lastname']"
                class="text-xs text-red-500"
                >{{ errors['lastname'][0] }}</span
              >
            </label>
            <label class="form__label">
              <span>{{ $t('commons.quoteForm.customerInfos.firstname.label') }}</span>
              <input
                v-model="form.firstname"
                :placeholder="$t('commons.quoteForm.customerInfos.firstname.placeholder')"
                class="form__input bg-lightgray md:bg-white"
                name="firstname"
                type="text" />
              <span
                v-if="errors && errors['firstname']"
                class="text-xs text-red-500"
                >{{ errors['firstname'][0] }}</span
              >
            </label>
          </div>
          <label class="form__label">
            <span>{{ $t('commons.quoteForm.customerInfos.email.label') }}</span>
            <input
              v-model="form.email"
              :placeholder="$t('commons.quoteForm.customerInfos.email.placeholder')"
              :disabled="$root.user.email"
              :class="$root.user.email ? 'bg-transparent' : 'bg-lightgray md:bg-white'"
              class="form__input"
              name="email"
              type="email" />
            <span
              v-if="errors && errors['email']"
              class="text-xs text-red-500"
              >{{ errors['email'][0] }}</span
            >
          </label>
          <div class="grid grid-cols-2 gap-x-4">
            <label class="form__label">
              <span>{{ $t('commons.quoteForm.customerInfos.country.label') }}</span>
              <select
                v-model="form.country"
                class="form__input bg-lightgray md:bg-white"
                name="country">
                <option
                  disabled
                  :value="null">
                  Sélectionner
                </option>
                <option
                  v-for="country in countriesList"
                  :value="country.value">
                  {{ country.label }}
                </option>
              </select>
              <span
                v-if="errors && errors['country']"
                class="text-xs text-red-500"
                >{{ errors['country'][0] }}</span
              >
            </label>
            <label class="form__label">
              <span>{{ $t('commons.quoteForm.customerInfos.phone.label') }}</span>
              <div class="relative h-auto w-full">
                <input
                  v-model="form.phone"
                  :placeholder="$t('commons.quoteForm.customerInfos.phone.placeholder')"
                  class="form__input w-full bg-lightgray md:bg-white"
                  name="phone"
                  required />
              </div>
              <span
                v-if="errors && errors['phone']"
                class="mt-2 text-xs text-red-500"
                >{{ errors['phone'][0] }}</span
              >
            </label>
          </div>
        </div>
      </div>

      <div class="w-full bg-lightgray px-6 py-4">
        <div class="flex w-full items-center">
          <svg
            class="h-4 w-4"
            fill="none"
            height="16"
            viewBox="0 0 15 16"
            width="15"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0 0V16H2V12H15V0H0ZM4 10H2V8H4V10ZM4 4H2V2H4V4ZM7 7H5V5H7V7ZM10 10H8V8H10V10ZM10 4H8V2H10V4ZM13 7H11V5H13V7Z"
              fill="#469752" />
          </svg>
          <h3 class="ml-4 font-poppins text-xl font-medium">
            {{ $t('accommodations.quoteForm.booking.title') }}
          </h3>
        </div>
        <div class="grid grid-cols-2 gap-x-4">
          <div class="form__label">
            <label for="start_date"
              ><span>{{ $t('accommodations.quoteForm.booking.inputs.start.label') }}</span></label
            >
            <input
              id="start_date"
              v-model="form.specific_fields.booking.start_date"
              class="form__input"
              type="date" />
            <span
              v-if="errors && errors['specific_fields.booking.start_date']"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.booking.start_date'][0] }}</span
            >
          </div>
          <div class="form__label">
            <label for="end_date"
              ><span>{{ $t('accommodations.quoteForm.booking.inputs.end.label') }}</span></label
            >
            <input
              id="end_date"
              v-model="form.specific_fields.booking.end_date"
              class="form__input"
              type="date" />
            <span
              v-if="errors && errors['specific_fields.booking.end_date']"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.booking.end_date'][0] }}</span
            >
          </div>
        </div>
        <div class="grid grid-cols-2 gap-x-4">
          <label class="form__label">
            <span>{{ $t('accommodations.quoteForm.booking.inputs.adults.label') }}</span>
            <select
              v-model="form.specific_fields.booking.adults"
              class="form__input bg-lightgray md:bg-white"
              name="number">
              <option
                disabled
                :value="null">
                Sélectionner
              </option>
              <option
                v-for="adult in 10"
                :value="adult">
                {{ adult }}
              </option>
            </select>
            <span
              v-if="errors && errors['specific_fields.booking.adults']"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.booking.adults'][0] }}</span
            >
          </label>
          <label class="form__label">
            <span>{{ $t('accommodations.quoteForm.booking.inputs.child.label') }}</span>
            <select
              v-model="form.specific_fields.booking.child"
              class="form__input bg-lightgray md:bg-white"
              name="number">
              <option
                disabled
                :value="null">
                Sélectionner
              </option>
              <option
                v-for="child in 11"
                :value="child - 1">
                {{ child - 1 }}
              </option>
            </select>
            <span
              v-if="errors && errors['specific_fields.booking.child']"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.booking.child'][0] }}</span
            >
          </label>
        </div>
        <div class="grid grid-cols-2 gap-x-4">
          <label class="form__label">
            <span>{{ $t('accommodations.quoteForm.booking.inputs.babies.label') }}</span>
            <select
              v-model="form.specific_fields.booking.babies"
              class="form__input bg-lightgray md:bg-white"
              name="number">
              <option
                disabled
                :value="null">
                Sélectionner
              </option>
              <option
                v-for="baby in 11"
                :value="baby - 1">
                {{ baby - 1 }}
              </option>
            </select>
            <span
              v-if="errors && errors['specific_fields.booking.babies']"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.booking.babies'][0] }}</span
            >
          </label>
        </div>

        <div class="mb-3 mt-2 flex flex-col">
          <label class="form__label">
            <span>{{ $t('accommodations.quoteForm.booking.inputs.message.label') }}</span>
            <textarea
              v-model="form.message"
              :placeholder="$t('accommodations.quoteForm.booking.inputs.message.placeholder')"
              class="mt-2 rounded-lg border border-light/25 bg-lightgray p-4 text-sm md:bg-white"
              name="comment">
            </textarea>
          </label>
          <span class="mt-4 font-sans text-xs text-light">{{ $t('commons.quoteForm.mentions') }}</span>
        </div>
      </div>

      <div class="mt-5 px-5 pb-5">
        <button
          class="btn"
          type="submit">
          {{ $t('buttons.send') }}
        </button>
      </div>
    </form>
  </div>
</template>
